import { useSetState } from 'ahooks'
import { Modal, Table } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const ReissueRecordsModal: React.FC<{
	detail: any
}> = ({ detail }) => {
	const [state, setState] = useSetState<{
		visible: boolean
	}>({
		visible: false,
	})

	useEffect(() => {
		setState({ visible: true })
	}, [])

	const columns = [
		{
			title: '短信通道',
			dataIndex: 'resendChannelName',
		},
		{
			title: '提交时间',
			dataIndex: 'resendSubmitTime',
			render: (value: any) => dayjs(value).format('YYYY-MM-DD HH:mm:ss'),
		},
		{
			title: '回执时间',
			dataIndex: 'resendReportTime',
			render: (value: any) => dayjs(value).format('YYYY-MM-DD HH:mm:ss'),
		},
		{
			title: '回执状态',
			dataIndex: 'resendReport',
		},
	]

	return (
		<Modal
			title="查看补发记录"
			width={700}
			footer={null}
			open={state.visible}
			onCancel={() => {
				setState({ visible: false })
			}}
		>
			<Table columns={columns} dataSource={detail?.resendDetail} pagination={false} rowKey={'resendChannelName'} />
		</Modal>
	)
}

export default ReissueRecordsModal
